export default __webpack_public_path__ + "static/KontorBeth-40ef72e57f31416b6abdf6ef37d1e7db.png";